// src/components/AuthHandler.tsx
import React, { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { loginUser } from '../services/apiService';
import { useUser } from '../contexts/UserContext';
import { getMyEntityConfig } from '../services/entityApiService';

const AuthHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { instance, accounts } = useMsal();
  const { setUser, setEntityConfig } = useUser();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (accounts.length > 0) {
      const account = accounts[0];
      setIsLoading(true);

      loginUser(instance, account)
        .then(async (user) => {
          setUser(user);
          console.log("Registered/Logged in app user:", user);
          try {
            const config = await getMyEntityConfig(instance, account);
            setEntityConfig(config);
          } catch {
            // Non-fatal — entity config defaults will apply
          }
        })
        .catch(err => {
          console.error(err);
          setError("Failed to register with the application. Please contact support.");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [instance, accounts, setUser, setEntityConfig]);

  if (isLoading) {
    return <div>Signing in to application...</div>;
  }

  if (error) {
    return <div style={{ color: 'red' }}>Error: {error}</div>;
  }

  return <>{children}</>;
};

export default AuthHandler;
